import {Transition} from "@headlessui/react";

interface SpinnerButtonProps extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>, React.AriaAttributes  {
  loading: boolean
  css?: string
  children?: React.ReactNode;
}

  export function SpinnerButton(props:SpinnerButtonProps) {

    const buttonCss = props.css ? props.css : "mt-3 inline-flex w-full items-center justify-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 sm:mt-0 sm:w-auto"

    return (
      <>
        <button
          type="submit"
          disabled={props.disabled || false}
          className={buttonCss}
          onClick={props.onClick}>
          <Transition
            show={props.loading}
            enter="transition ease-in-out duration-400 transform"
            enterFrom="-translate-x-full"
            enterTo="translate-x-0"
            leave="transition ease-in-out duration-400 transform"
            leaveFrom="translate-x-0"
            leaveTo="-translate-x-full">
            <svg className="animate-spin h-5 w-5 mr-3 ..." viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" fill="transparent" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </Transition>
          {props.children ? props.children : 'Create'}
        </button>
      </>
    )

  }